import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useProjectAskDetail = (id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [askInfo, setAskInfo] = useState<ProjectAskInfoDto>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading } = useQuery(
    [endpoints.project.ask.info, id],
    () =>
      fetcher.project.postProjectAskInfo({id: id}),
    {
      enabled: id > 0,
      onSuccess: (res: ProjectAskInfoResDto) => {
        switch (res.code) {
          case 200:
            setAskInfo(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: askInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.project.ask.add],
    fetcher.project.postProjectAskInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: askUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.project.ask.update],
    fetcher.project.postProjectAskUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: askDelete, isSuccess: deleteSuccess } = useMutation(
    [endpoints.project.ask.delete],
    fetcher.project.postProjectAskDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { isLoading, askInfo, insertSuccess, updateSuccess, deleteSuccess, askInsert, askUpdate, askDelete };
};

export default useProjectAskDetail;
